/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChargerMeterValueDto
 */
export interface ChargerMeterValueDto {
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    chargerMeterValueId?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    transactionId?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    stateOfCharge?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    currentOfferedA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    powerOfferedW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    gridActivePowerExportW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    gridActivePowerImportW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    solarActivePowerImportW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    gridActiveEnergyExportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    gridActiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    solarEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    totalCost?: number;
    /**
     *
     * @type {Date}
     * @memberof ChargerMeterValueDto
     */
    timestamp?: Date;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    frequencyHz?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l1VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l2VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l3VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l1CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l2CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l3CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l1ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l2ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l3ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l1ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l2ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    l3ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    totalActiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    totalReactiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    totalActiveEnergyExportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValueDto
     */
    totalReactiveEnergyExportWh?: number;
}

/**
 * Check if a given object implements the ChargerMeterValueDto interface.
 */
export function instanceOfChargerMeterValueDto(
    value: object,
): value is ChargerMeterValueDto {
    return true;
}

export function ChargerMeterValueDtoFromJSON(json: any): ChargerMeterValueDto {
    return ChargerMeterValueDtoFromJSONTyped(json, false);
}

export function ChargerMeterValueDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChargerMeterValueDto {
    if (json == null) {
        return json;
    }
    return {
        chargerMeterValueId:
            json["chargerMeterValueId"] == null
                ? undefined
                : json["chargerMeterValueId"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        stateOfCharge:
            json["stateOfCharge"] == null ? undefined : json["stateOfCharge"],
        currentOfferedA:
            json["currentOfferedA"] == null
                ? undefined
                : json["currentOfferedA"],
        powerOfferedW:
            json["powerOfferedW"] == null ? undefined : json["powerOfferedW"],
        gridActivePowerExportW:
            json["gridActivePowerExportW"] == null
                ? undefined
                : json["gridActivePowerExportW"],
        gridActivePowerImportW:
            json["gridActivePowerImportW"] == null
                ? undefined
                : json["gridActivePowerImportW"],
        solarActivePowerImportW:
            json["solarActivePowerImportW"] == null
                ? undefined
                : json["solarActivePowerImportW"],
        gridActiveEnergyExportWh:
            json["gridActiveEnergyExportWh"] == null
                ? undefined
                : json["gridActiveEnergyExportWh"],
        gridActiveEnergyImportWh:
            json["gridActiveEnergyImportWh"] == null
                ? undefined
                : json["gridActiveEnergyImportWh"],
        solarEnergyImportWh:
            json["solarEnergyImportWh"] == null
                ? undefined
                : json["solarEnergyImportWh"],
        totalCost: json["totalCost"] == null ? undefined : json["totalCost"],
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        frequencyHz:
            json["frequencyHz"] == null ? undefined : json["frequencyHz"],
        l1VoltageRmsV:
            json["l1VoltageRmsV"] == null ? undefined : json["l1VoltageRmsV"],
        l2VoltageRmsV:
            json["l2VoltageRmsV"] == null ? undefined : json["l2VoltageRmsV"],
        l3VoltageRmsV:
            json["l3VoltageRmsV"] == null ? undefined : json["l3VoltageRmsV"],
        l1CurrentRmsA:
            json["l1CurrentRmsA"] == null ? undefined : json["l1CurrentRmsA"],
        l2CurrentRmsA:
            json["l2CurrentRmsA"] == null ? undefined : json["l2CurrentRmsA"],
        l3CurrentRmsA:
            json["l3CurrentRmsA"] == null ? undefined : json["l3CurrentRmsA"],
        l1ActivePowerRmsW:
            json["l1ActivePowerRmsW"] == null
                ? undefined
                : json["l1ActivePowerRmsW"],
        l2ActivePowerRmsW:
            json["l2ActivePowerRmsW"] == null
                ? undefined
                : json["l2ActivePowerRmsW"],
        l3ActivePowerRmsW:
            json["l3ActivePowerRmsW"] == null
                ? undefined
                : json["l3ActivePowerRmsW"],
        l1ReactivePowerRmsVar:
            json["l1ReactivePowerRmsVar"] == null
                ? undefined
                : json["l1ReactivePowerRmsVar"],
        l2ReactivePowerRmsVar:
            json["l2ReactivePowerRmsVar"] == null
                ? undefined
                : json["l2ReactivePowerRmsVar"],
        l3ReactivePowerRmsVar:
            json["l3ReactivePowerRmsVar"] == null
                ? undefined
                : json["l3ReactivePowerRmsVar"],
        totalActiveEnergyImportWh:
            json["totalActiveEnergyImportWh"] == null
                ? undefined
                : json["totalActiveEnergyImportWh"],
        totalReactiveEnergyImportWh:
            json["totalReactiveEnergyImportWh"] == null
                ? undefined
                : json["totalReactiveEnergyImportWh"],
        totalActiveEnergyExportWh:
            json["totalActiveEnergyExportWh"] == null
                ? undefined
                : json["totalActiveEnergyExportWh"],
        totalReactiveEnergyExportWh:
            json["totalReactiveEnergyExportWh"] == null
                ? undefined
                : json["totalReactiveEnergyExportWh"],
    };
}

export function ChargerMeterValueDtoToJSON(
    value?: ChargerMeterValueDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        chargerMeterValueId: value["chargerMeterValueId"],
        transactionId: value["transactionId"],
        stateOfCharge: value["stateOfCharge"],
        currentOfferedA: value["currentOfferedA"],
        powerOfferedW: value["powerOfferedW"],
        gridActivePowerExportW: value["gridActivePowerExportW"],
        gridActivePowerImportW: value["gridActivePowerImportW"],
        solarActivePowerImportW: value["solarActivePowerImportW"],
        gridActiveEnergyExportWh: value["gridActiveEnergyExportWh"],
        gridActiveEnergyImportWh: value["gridActiveEnergyImportWh"],
        solarEnergyImportWh: value["solarEnergyImportWh"],
        totalCost: value["totalCost"],
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        frequencyHz: value["frequencyHz"],
        l1VoltageRmsV: value["l1VoltageRmsV"],
        l2VoltageRmsV: value["l2VoltageRmsV"],
        l3VoltageRmsV: value["l3VoltageRmsV"],
        l1CurrentRmsA: value["l1CurrentRmsA"],
        l2CurrentRmsA: value["l2CurrentRmsA"],
        l3CurrentRmsA: value["l3CurrentRmsA"],
        l1ActivePowerRmsW: value["l1ActivePowerRmsW"],
        l2ActivePowerRmsW: value["l2ActivePowerRmsW"],
        l3ActivePowerRmsW: value["l3ActivePowerRmsW"],
        l1ReactivePowerRmsVar: value["l1ReactivePowerRmsVar"],
        l2ReactivePowerRmsVar: value["l2ReactivePowerRmsVar"],
        l3ReactivePowerRmsVar: value["l3ReactivePowerRmsVar"],
        totalActiveEnergyImportWh: value["totalActiveEnergyImportWh"],
        totalReactiveEnergyImportWh: value["totalReactiveEnergyImportWh"],
        totalActiveEnergyExportWh: value["totalActiveEnergyExportWh"],
        totalReactiveEnergyExportWh: value["totalReactiveEnergyExportWh"],
    };
}
